import { Injectable } from "@angular/core";
import { AppHttpService, LocalStorageService } from "@core";
import { LocalStorageKey } from "@model";
import { forkJoin, from, Observable } from "rxjs";

const MAX_CHECK_TIME_INTERVAL = 60 * 60 * 1000; // one hour

@Injectable({ providedIn: "root" })
export class PwaUpdateService {
  constructor(
    private _localStorageService: LocalStorageService,
    private _appHttpService: AppHttpService,
  ) {}

  private _lastCheckedTime = 0;

  checkVersion(): void {
    const savedVersion = this._localStorageService.get(LocalStorageKey.APP_VERSION);
    const currentTime = new Date().getTime();
    if (currentTime - this._lastCheckedTime > MAX_CHECK_TIME_INTERVAL) {
      this._loadCurrentVersion().subscribe((currentVersion) => {
        if (savedVersion !== currentVersion) {
          this._localStorageService.set(LocalStorageKey.APP_VERSION, currentVersion);
          this._reloadWorker();
          this._lastCheckedTime = currentTime;
        }
      });
    }
  }

  private _loadCurrentVersion(): Observable<string> {
    const url = "/api/get-current-version";
    return this._appHttpService.makeGETRequest<string>(url);
  }

  private _reloadWorker(): void {
    //https://stackoverflow.com/questions/52221805/any-way-yet-to-auto-update-or-just-clear-the-cache-on-a-pwa-on-ios
    if ("serviceWorker" in navigator) {
      from(navigator.serviceWorker.getRegistrations()).subscribe((registrations) => {
        const promises = registrations.map((r) => r.unregister());
        forkJoin(promises).subscribe(() => {
          window.location.reload();
        });
      });
    }
  }
}
